/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-09-18 21:46:02 
 * @Last Modified by:   syyoon@yongtrim.com 
 * @Last Modified time: 2018-09-18 21:46:02 
 */



import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENV } from '../env/env';
import { TransService } from './trans.service';

@Injectable()
export class PostService {

  private url = `${ENV.SERVER_URL}/${ENV.API_PATH}/posts`;

  constructor(
    private transService: TransService,
    private http: HttpClient) {
  }

  getPostByTag(tag: string) {
    return this.http.get(`${this.url}/tag/${tag}?lang=${this.transService.lang}`);
  }

  updatePostByTag(tag: string, data) {
    return this.http.put(`${this.url}/tag/${tag}?lang=${this.transService.lang}`, data);
  }
}



// WEBPACK FOOTER //
// ./src/services/post.service.ts